import React from 'react'

var d = new Date();
var currYear = d.getFullYear();
export const Copyright = (props) => {
    return (

        <div class="container-fluid cpr-bottom">
            <div class="container">
                <p style={{ alignItems: 'center' }}>© Copyright {currYear} RO Repair Care . All rights reserved &nbsp; | &nbsp;Designed & Developed by{" "}
                    <a href="https://wappotix.com/" target="_blank" rel="noopener noreferrer">Wappotix Private Limited</a> | &nbsp; <a href="/privacy-policy">Privacy Policy </a></p>
            </div>
        </div>

    );
};
